export default "__VITE_ASSET__36730124__"